export const MIN_PITCH = 0.0;
export const MAX_PITCH = 2.0;
export const INCREMENT_PITCH = 0.25;
export const MIN_RATE = 0;
export const MAX_RATE = 2;
export const INCREMENT_RATE = 0.25;
export const MIN_ELEVENLABS_SPEED = 0.7;
export const MAX_ELEVENLABS_SPEED = 1.2;
export const INCREMENT_ELEVENLABS_SPEED = 0.05;
export const MIN_ELEVENLABS_STABILITY = 0;
export const MAX_ELEVENLABS_STABILITY = 1;
export const INCREMENT_ELEVENLABS_STABILITY = 0.05;
export const MIN_ELEVENLABS_SIMILARITY = 0;
export const MAX_ELEVENLABS_SIMILARITY = 1;
export const INCREMENT_ELEVENLABS_SIMILARITY = 0.05;
export const MIN_ELEVENLABS_STYLE = 0;
export const MAX_ELEVENLABS_STYLE = 1;
export const INCREMENT_ELEVENLABS_STYLE = 0.05;
